/* eslint-disable no-unused-vars */
import React, {Component} from 'react';
import {render} from 'react-dom';
import MapGL, { FlyToInterpolator } from 'react-map-gl';
import {json as requestJson} from 'd3-request';
import * as d3 from 'd3-ease'
import {fromJS} from 'immutable';
import WebMercatorViewport from 'viewport-mercator-project';
import _ from 'lodash';
import {
  firebaseConnect,
  isLoaded,
  isEmpty
} from 'react-redux-firebase';
import { Loader, Statistic, Modal, Button, Icon, Header } from 'semantic-ui-react';
import ControlPanel from './control-panel';
import { getFeaturesForLineAnimation } from './utils';

// import { getFeaturesFromGeoFire } from './utils';
import {defaultMapStyle, animatedLinesLayer, clustersLayer, unclusteredLayer, ogCloudLayer, allSessionsLayer} from './map-style.js';

export const MARGIN_LEFT = 30;

export default class App extends Component {

  state = {
    mapStyle: '',
    loading: true,
    viewport: {

      // latitude: 0,
      // longitude: 0,
      // zoom: 7,

      longitude: -80.01006424427032,
      latitude: 33.080970305956555,
      zoom: 11,

      bearing: 0,
      pitch: 0,
      width: 500,
      height: 500,
      maxZoom: 15,
      minZoom: 1,
      isInteractive: false,
      scrollZoom: false,
      dragPan: false,
      touchZoom: false,
      doubleClickZoom: false,
      keyboard: false,

    },
    features: [],
    sessions: {},
    visibleSessions: [],
    featureCounter: 0,
    coordinateCounter: 0,
    animatedLines: 0,
  }

  componentDidMount() {
    window.addEventListener('resize', this._resize);
    this._resize();
    if(this.state.loading && isLoaded(this.props.sessions))
      this._loadData();
  }

  componentDidUpdate(prevProps) {
    const { loading } = this.state;
    if(loading && isLoaded(this.props.sessions))
      this._loadData();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._resize);
  }

  // -------------------------------------
  // Data Functions
  // -------------------------------------

  _loadData = () => {
    // load flattened session data
    const { sessions } = this.props;
    var features = _.values(sessions); // convert to array
    this._initializeMapStyle(features);
    this.setState({sessions, features});
  }

  // -------------------------------------
  // Initialize Map
  // -------------------------------------

  _initializeMapStyle = (features) => {
    this.setState({mapStyle: defaultMapStyle,loading: false,});
  }

  _addSessionDataSource = () => {

    const clusteredSessions = {
      type: 'geojson',
      data: {
        "type": "FeatureCollection",
        "features" : fromJS(this.state.features),
      },
      cluster: true,
      clusterMaxZoom: 11, // Max zoom to cluster points on
      clusterRadius: 50 // Radius of each cluster when clustering points (defaults to 50)
    };

    const unclustedSessions = {
      type: 'geojson',
      data: {
        "type": "FeatureCollection",
        "features" : fromJS(this.state.features),
      }
    };


    // var lines = {
    //   "type": "FeatureCollection",
    //   "features": [],
    //   // "features": lineFeaturesForAnimation.emptyFeatures
    // };

    var mapStyle = this.state.mapStyle
      .setIn(['sources', 'sessions'], fromJS(unclustedSessions))
      .setIn(['sources', 'clustered-sessions'], fromJS(clusteredSessions))
      // .setIn(['sources', 'lines'], fromJS({type: 'geojson',data: lines}))
    //
      mapStyle = mapStyle
        .set('layers', mapStyle.get('layers').push(clustersLayer))

      mapStyle = mapStyle
        .set('layers', mapStyle.get('layers').push(unclusteredLayer))

      mapStyle = mapStyle
        .set('layers', mapStyle.get('layers').push(ogCloudLayer))

      mapStyle = mapStyle
        .set('layers', mapStyle.get('layers').push(allSessionsLayer))




      this.setState({mapStyle})
  }

  _addNightStyle = () => {
      console.log('_addNightStyle');
      this.map.setStyle("mapbox://styles/mapbox/dark-v9");
  }


  _onMapLoad = event => {
    this.map = this.mapRef.getMap()
    this._addNightStyle();
    event.target.on('style.load', this._onStyleLoad );
    event.target.on('move', this._onMapMove );
  }

  // -------------------------------------
  // Settings Functions
  // -------------------------------------
  _onStyleLoad = () => {
    this._addSessionDataSource();

    // also add image to map
    this.map.loadImage('/images/cloud_small.png', (error, image) => {
        if (error) throw error;
        this.map.addImage('cloud', image);
        if(localStorage.getItem('viewedMapAlready')) {
          console.log('user been here before')
          this.setState({firstVisit: false});
          this._initialZoomOutDone()
        } else {
          console.log('first time! set local storage');
          localStorage.setItem('viewedMapAlready', true);
          this.setState({firstVisit: true});
          this._initialZoomOutDone()
        }
      });
  }

  // -------------------------------------
  // Viewport Functions
  // -------------------------------------

  _onMapMove = () => {
    const bounds = this.map.getBounds();
    let visibleSessions = this.map.queryRenderedFeatures({layers:['all-sessions']});
    visibleSessions = _.uniqBy(visibleSessions, 'properties.id');
    this.setState({visibleSessions});

  }
  _resize = () => {
    this.setState({
      viewport: {
        ...this.state.viewport,
        width: window.innerWidth,
        height: window.innerHeight
      }
    });
  };
  _onViewportChange = viewport => {
    this.setState({viewport: {...this.state.viewport, ...viewport}});
  }




  // -------------------------------------
  // Map Interaction Functions
  // -------------------------------------


  _beginSlowZoomOut = (features) => {
    // console.log('_beginSlowZoomOut',)
    this._onViewportChange({
      zoom: 1,
      transitionInterpolator: new FlyToInterpolator(),
      transitionDuration: 17000,
      transitionEasing: d3.easeQuadOut,
      onTransitionEnd: this._initialZoomOutDone
    });
    return;
  }

  _initialZoomOutDone = () => {
    // this.map.setLayoutProperty("cloud", "visibility", "none");

    this._setMapAsInteractive()
    // this.setState({zoomDone: true});

    // todo remove cloud og layer

  }

  _setMapAsInteractive = () => {
    this._onViewportChange({
      isInteractive: true,
      scrollZoom: true,
      dragPan: true,
      touchZoom: true,
      doubleClickZoom: true,
      keyboard: true,
      zoom: 4,
    })
  }



  _onMapClick = event => {
    console.log('clicked',event.features);
    const ogCloudClicked = _.filter(event.features,f=>f.layer.id ==='cloud');
    if(ogCloudClicked.length > 0)
      return this._beginSlowZoomOut(event.features);

    if(_.filter(event.features,f=>f.layer.id ==='unclustered-point').length > 0)
        return this._onCloudClick(event.features);
    return;

  }

  _onCloudClick = (features) => {
    var key = features[0].properties.id;
    console.log(features[0])
    this._removeCloudByKey(key);
    this._animateSessionByKey(key);
  }

  _removeCloudByKey = (key) => {

    var mapStyle = this.state.mapStyle
      .updateIn(['sources', 'clustered-sessions', 'data', 'features'], features => {
        console.log('features',features)
        var newFeatures = features.filter( f => f.get('properties').get('id') !== key);
        console.log('newFeatures',newFeatures)
        return newFeatures;
      });

      // .updateIn(['sources', 'unclustered-point', 'data', 'features'], features => _.filter(features,f=> f.properties.id !== key));

    this.setState({mapStyle});

  }

  _animateSessionByKey = (key) => {

    this.props.firebase.database().ref('/geoFire/' + key).once("value", snapshot => {
      var session = snapshot.val()
      // console.log('session',session);
      const lineFeaturesForAnimation = getFeaturesForLineAnimation(session);
      const flatLines = _.flatten(lineFeaturesForAnimation.featuresCoordinates);
      // console.log('lineFeaturesForAnimation',lineFeaturesForAnimation);
      // console.log('flatLines',flatLines);

      var lines = {
        "type": "FeatureCollection",
        "features": lineFeaturesForAnimation.emptyFeatures
      };

      var mapStyle = this.state.mapStyle
        .setIn(['sources', 'lines'], fromJS({type: 'geojson',data: lines}));

        mapStyle = mapStyle
            .set('layers', mapStyle.get('layers').push(animatedLinesLayer))

      // load data?
      this.setState({
        mapStyle,
        // loading: false,
        emptyFeatures: lineFeaturesForAnimation.emptyFeatures,
        featuresCoordinates: lineFeaturesForAnimation.featuresCoordinates,
        originCoordinates: lineFeaturesForAnimation.originCoordinates,
        flatLines,
      });

      this._startAnimation();
    })


  }
  _startAnimation = () => {
    // console.log('start')
    this._animate();
  }


  _animate = () => {

    const { emptyFeatures, mapStyle, animationCounter, featuresCoordinates, featureCounter, coordinateCounter } = this.state
    // console.log(this.state)
    setTimeout( () => {

      const newMapStyle = mapStyle
        // .updateIn(['sources', 'lines', 'data', 'features', featureCounter, 'geometry', 'coordinates'], coordinates => coordinates.concat(featuresCoordinates[featureCounter]));
        .setIn(['sources', 'lines', 'data', 'features', featureCounter, 'geometry', 'coordinates', coordinateCounter],  featuresCoordinates[featureCounter][coordinateCounter] );


      if (coordinateCounter < featuresCoordinates[featureCounter].length - 1) {
        // console.log('if')
        // then we are still drawing a line, continue
        this.setState({
          mapStyle: newMapStyle,
          coordinateCounter: coordinateCounter + 1,
        });
        requestAnimationFrame(this._animate);

      } else if (featureCounter < emptyFeatures.length - 1) {
        // console.log('elseif ')
        // then we finished drawings a line, now start  the next line
        this.setState({
          mapStyle: newMapStyle,
          coordinateCounter: 0,
          featureCounter: featureCounter + 1,
        });
        requestAnimationFrame(this._animate);

      } else {
        // console.log('else')
        // var mapStyle = this.state.mapStyle
        //   .updateIn(['layers', 'cloud', 'source', 'data', 'features'], features => {
        //     console.log('features',features)
        //     var newFeatures = features.filter( f => f.get('properties').get('id') !== key);
        //     console.log('newFeatures',newFeatures)
        //     return newFeatures;
        //   });

        this.setState({
          animatedLines: this.state.animatedLines + 1,
          featureCounter: 0,
          coordinateCounter: 0,
        })
      }

}, 30 );

  }

  render() {
    const {viewport, mapStyle, loading} = this.state;
    if(loading) { return <Loader active /> }

    return (
      <div>
      <MapGL
        ref={(el) => this.mapRef = el}
        {...viewport}
        mapStyle={mapStyle}
        onViewportChange={this._onViewportChange}
        mapboxApiAccessToken={this.props.MAPBOX_TOKEN}
        onClick={this._onMapClick}
        onLoad={this._onMapLoad}
        >


      </MapGL>
      <p style={{position: 'absolute', bottom: 30, left: 30, color: 'red'}}>{false && this.state.viewport.zoom}</p>


      <div style={{position: 'absolute', top: 30, right: 30}}>
      <Statistic size='large' inverted>
      <Statistic.Value>{this.state.animatedLines > 0 && this.state.animatedLines}</Statistic.Value>
    </Statistic>
    </div>




      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/pages/NightMap/Map.js